module.exports = __webpack_public_path__ + "static/jacksonvillebigsign-0fdc480a4ae3b7f35d25e3aef1dff032.jpg";